import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var gqlGetAsset = gql`
  query GetAsset($organizationId: UUID!, $assetId: UUID!) {
    asset(organizationId: $organizationId, assetId: $assetId) {
     id
      name
    }
  }
`;



export function apiGetAssetMinimal(organizationId, assetId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: gqlGetAsset,
                variables: {organizationId, assetId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.asset);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset");
                reject(err); // R
            })
    });
}
